import { useSelector } from 'react-redux';
import { getModal } from '../reducers';

const useModalShow = () => {
  const openModal = useSelector(getModal);
  return { openModal };
};

export default useModalShow;
